<template>
    <div class="app">

        <!-- BACKGROUND -->
        <div class="bg" :style="background">
            <div class="bg-overlay" :style="backgroundOverlay"></div>
        </div>

        <!-- MENU -->
        <nav class="menu" :class="{open: hambOpen}">
            <ul class="links">
                <li>
                    <router-link :to="{name: 'entrada'}" v-html="'Entrada'"></router-link>
                </li>
                <li>
                    <router-link :to="{name: 'quemSomos'}" v-html="'Quem Somos'"></router-link>
                </li>
                <li>
                    <router-link :to="{name: 'queFazemos'}" v-html="'O Que Fazemos'"></router-link>
                </li>
                <li>
                    <router-link :to="{name: 'portfolio'}" v-html="'Portfólio'"></router-link>
                </li>
                <li>
                    <router-link :to="{name: 'contactos'}" v-html="'Contactos'"></router-link>
                </li>
            </ul>
            <a href="tel:933419480" class="ligar">
                <button class="btn">
                    <i class="fa fa-phone"></i>
                    <span>Ligar Agora</span>
                </button>
            </a>
        </nav>

        <!-- HEADER -->
        <div id="header">
            <div class="logo">
                <router-link v-if="logo" :to="{name: 'entrada'}" >
                    <img class="logoImg" src="/images/logo_black_small.png" alt="">
                </router-link>
            </div>
            <div class="hamburger">
                <button class="my-auto" @click="hambOpen = !hambOpen">
                    <div class="bar1">
                        <span class="dot"></span>
                        <span class="bar"></span>
                    </div>
                    <div class="bar2">
                        <span class="dot"></span>
                        <span class="bar"></span>
                    </div>
                    <div class="bar3">
                        <span class="dot"></span>
                        <span class="bar"></span>
                    </div>
                </button>
            </div>
        </div>

        <!-- VIEW -->
        <router-view class="view"></router-view>

        <div class="footer" :style="footer">
            <div class="text-right devBy">
                <p>Desenvolvido por <a href="https://duplanet.pt">Duplanet.pt</a>
                    <br>&copy Todos os direitos reservados {{ new Date().getFullYear() }}
                </p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "HomeComponent",
        metaInfo: {
            title: 'OnPrint',
            titleTemplate: 'OnPrint | %s'
        },
        data() {
            return {
                background: {},
                backgroundOverlay: {},
                footer: {},
                hambOpen: false,
                logo: true
            }
        },
        watch: {
            $route(to, from) {
                this.hambOpen = false;
                this.background = {};
                this.backgroundOverlay = {};
                this.footer = {};
                this.hambOpen = false;
                this.logo = true;
            }
        }
    }
</script>

<style>
    button, .btn {
        outline: none !important;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #832700;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #F07720;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #ff2e01;
    }

</style>

<style lang="scss" scoped>

    #header {
        display: flex;
        position: relative;
        top: 0;
        left: 0;
        right: 0;

        .logo {
            flex: 1;
            max-height: 102px;

            img {
                width: 50vw;
                object-position: left;
                object-fit: contain;
                height: 100%;
            }
        }

        .hamburger {
            height: auto;
            display: flex;
            flex-direction: column;
            padding: 35px;
            z-index: 9;

            button {
                background: transparent;
                border: none;
            }

            .bar1, .bar2, .bar3 {
                display: flex;
                height: 10px;

                .dot {
                    background: #F07720;
                    border-radius: 50%;
                    width: 5px;
                    height: 5px;
                    margin-right: 2px;
                }

                .bar {
                    background: #fff;
                    border-radius: 25%;
                    width: 30px;
                    height: 5px;
                }
            }
        }

    }

    .ligar {
        .btn {
            color: #fff;
            font-size: 1.5rem;
            padding-top: 40px;
        }

        i {
            background-color: #F07720;
            padding: 5px;
            border-radius: 50%;
            width: 1.5em;
        }
    }

    .app {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: #c9c9c9;
    }

    .footer {
        position: relative;
        color: #fff;
        padding: 5px;

        a {
            color: #F07720;
            text-decoration: none;
        }
    }

    .menu {
        background: rgba(0, 0, 0, .95);
        position: fixed;
        top: 0;
        Bottom: 0;
        right: 0;
        padding: 145px 35px 35px;
        text-align: right;
        width: 30vw;
        min-width: 350px;
        max-width: 100vw;
        color: #fff;
        transition: all .5s ease;
        font-size: 2rem;
        border-left: 1px solid #F07720;
        z-index: 9;

        &:not(.open) {
            right: -100vw;
        }

        ul.links {
            list-style: none;
            padding: 0;
            margin: 0;

            .router-link-exact-active::before {
                content: "\2022";
                color: #F07720;
                font-weight: bold;
                display: inline-block;
                width: 1em;
                padding-right: .5rem;
            }

            li {
                display: block;
            }

            a, a:hover {
                text-decoration: none;
                color: inherit;
            }
        }
    }

    .bg {
        z-index: 0;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-position: top right;
        background-size: cover;
        background-repeat: no-repeat;
        transition: all .5s ease;

        .bg-overlay {
            transition: all .5s ease;
            height: 100%;
        }
    }

    .view {
        position: relative;
        color: #fff;
        flex: 1;
    }


</style>
